module.exports = __webpack_public_path__ + "static/logo-0d8ac23af7c47a767122145436d79ecd.png";